import React, {Component} from 'react';
import * as R from 'ramda';
import Plotly from 'plotly.js/dist/plotly';
import classNames from 'classnames';

const AGE_RANGE = window.sn.AgeRange;

class AgeAnalytics extends Component {
    componentDidMount() {
        const ages = this.calculateAges();
        this.drawAgesPlotly(ages);
    }

    calculateAges = () => {
        const {ageRangeCount} = this.props;

        const agesLabels = [
            AGE_RANGE.AGE_35_TO_52,
            AGE_RANGE.AGE_26_TO_34,
            AGE_RANGE.AGE_19_TO_25,
            AGE_RANGE.AGE_16_TO_18,
            AGE_RANGE.AGE_13_TO_15
        ];
        const agesValues = R.map(age => ageRangeCount[age], agesLabels);

        return {
            agesLabels,
            agesValues
        };
    };

    drawAgesPlotly = ages => {
        const {elementId, bgColor} = this.props;
        const graphEl = document.getElementById(elementId);
        const {agesLabels, agesValues} = ages;

        const data = [
            {
                type: 'pie',
                values: agesValues,
                labels: R.map(label => `<b>${label}</b>`, agesLabels),
                hoverinfo: 'none',
                textinfo: 'label+percent',
                sort: true,
                pull: 0.01,
                marker: {
                    colors: ['#4ed2c3', '#ffb50e', '#f96f48', '#2c97de', '#c96be5']
                },
                insidetextfont: {
                    family: 'Open Sans',
                    size: 14,
                    color: '#FFF'
                },
                outsidetextfont: {
                    family: 'Open Sans',
                    size: 12,
                    color: 'rgb(78, 210, 195)'
                }
            }
        ];

        const graphBgColor = bgColor || '#FFF';

        const layout = {
            autosize: true,
            width: 350,
            height: 300,
            margin: {
                t: 0,
                b: 0,
                pad: 10
            },
            showlegend: false,
            paper_bgcolor: graphBgColor,
            plot_bgcolor: graphBgColor
        };

        Plotly.plot(graphEl, data, layout, {
            displayModeBar: false,
            displaylogo: false
        });
    };

    render() {
        const {elementId, borders, renderForPdf} = this.props;
        const ageAnalyticsClasses = classNames('age-analytics', {
            'container-border-top': borders.top,
            'container-border-right': borders.right,
            'container-border-bottom': borders.bottom,
            'container-border-left': borders.left
        });

        return (
            <div className={ageAnalyticsClasses}>
                <div className="age-header">AGE</div>
                <div className="age-pie-chart">
                    <div id={elementId} />
                </div>

                {/*SYTLES*/}

                <style>{`
                    .age-analytics {
                        width: 50%;
                    }

                    .age-header {
                        font-size: 20px;
                        font-weight: bold;
                        color: #000;
                        padding-bottom: 20px;
                    }

                    .age-pie-chart {
                        position: relative;
                        bottom: 20px;
                    }

                    .container-border-top {
                        border-top: 1px solid #d4d4d4;
                    }

                    .container-border-right {
                        border-right: 1px solid #d4d4d4;
                    }

                    .container-border-bottom {
                        border-bottom: 1px solid #d4d4d4;
                    }

                    .container-border-left {
                        border-left: 1px solid #d4d4d4;
                    }
                `}</style>

                {/*STYLE FOR WEB*/}
                {!renderForPdf ? (
                    <style>{`
                        .age-analytics {
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                        }

                        .age-pie-chart {
                            display: flex;
                            justify-content: center;
                            align-items: center;
                        }
                    `}</style>
                ) : null}

                {/*STYLE FOR PDF*/}
                {renderForPdf ? (
                    <style>{`
                        .age-analytics {
                            display: inline-block;
                            vertical-align: top;
                            width: 49%;
                        }

                        .age-pie-chart {
                        }
                    `}</style>
                ) : null}
            </div>
        );
    }
}

AgeAnalytics.propTypes = {};

export default AgeAnalytics;



// WEBPACK FOOTER //
// ./campaign_analytics/campaign_wrap_up/analytics_shared/age_analytics.js